<script setup lang="ts">
  import { IconShieldUser } from '../lucide-icons'
  import { type HTMLAttributes } from 'vue'
  import { cn } from '../cn'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>

<template>
  <component :is="IconShieldUser" :class="cn('size-4', props.class)" />
</template>
